module.exports = __webpack_public_path__ + "img/slices.8cdb018f.svg";